export default __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu7WxKOzY.woff2";